const IMAGES_PATH = '/assets/images';

export const heroImg = `${IMAGES_PATH}/heroImg`;
export const printer = `${IMAGES_PATH}/printer.png`;
export const forms = `${IMAGES_PATH}/forms.png`;
export const image = `${IMAGES_PATH}/image.png`;
